import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useData } from '../../context/DataContext';
import { useNavigate } from 'react-router-dom';
import { BookOpen, Users, ArrowRight } from 'lucide-react';

export default function FacultyClasses() {
    const { user } = useAuth();
    const { fetchMyMappings } = useData();
    const [myClasses, setMyClasses] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            fetchMyMappings(user.id).then(data => {
                setMyClasses(data);
                setLoading(false);
            });
        }
    }, [user]);

    if (loading) return <div>Loading classes...</div>;

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-2xl font-bold font-heading text-primary">My Classes</h1>
                <p className="text-muted-foreground">Select a class to mark attendance</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {myClasses.length === 0 ? (
                    <div className="col-span-full text-center py-12 bg-card rounded-2xl border border-dashed border-border">
                        <p className="text-muted-foreground">No classes assigned to you.</p>
                    </div>
                ) : (
                    myClasses.map(cls => (
                        <div key={cls.id} className="bg-card border border-border rounded-xl p-6 shadow-sm hover:shadow-md transition-all group">
                            <div className="flex items-start justify-between mb-4">
                                <div className="h-12 w-12 bg-primary/10 rounded-xl flex items-center justify-center text-primary">
                                    <BookOpen size={24} />
                                </div>
                                <span className="bg-secondary px-2.5 py-1 rounded-full text-xs font-medium text-muted-foreground">
                                    {cls.subjectCode}
                                </span>
                            </div>

                            <h3 className="text-lg font-bold text-foreground mb-1">{cls.subjectName}</h3>
                            <div className="flex items-center gap-2 text-sm text-muted-foreground mb-6">
                                <Users size={16} />
                                <span>{cls.sectionName}</span>
                            </div>

                            <button
                                onClick={() => navigate(`/dashboard/attendance/${cls.id}`)}
                                className="w-full bg-secondary hover:bg-primary hover:text-primary-foreground text-foreground font-medium py-2.5 rounded-lg transition-colors flex items-center justify-center gap-2"
                            >
                                <span>Mark Attendance</span>
                                <ArrowRight size={16} />
                            </button>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}
